import { z } from 'zod';

/**
 * Credits are a way to pay for services in advance.
 * They are stored at the root level of the services provider and are used to pay Ekho commission.
 * Credits will be added to the services provider o	bject in shared db
 */
const creditsSchema = z.object({
    balance: z.number(), // current balance of the credits
    totalLoaded: z.number().optional(), // total amount of credits ever loaded into the account
    dateUpdated: z.number().optional(), // timestamp of the last update to the balance
    currency: z.string().optional(), // currency of the credits
    supported: z.boolean(), // true if credits are supported by the services provider
});
/**
 * credit transaction types
 * LOAD: when a credit is loaded into the account
 * DEDUCT: when a credit is deducted from the account
 * REFUND: when a credit is refunded to the account
 */
const CreditTransactionType = {
    LOAD: 'LOAD',
    DEDUCT: 'DEDUCT',
    REFUND: 'REFUND',
};
const creditTransactionTypeValues = [
    CreditTransactionType.LOAD,
    CreditTransactionType.DEDUCT,
    CreditTransactionType.REFUND,
];
const creditTransactionTypeSchema = z.enum(creditTransactionTypeValues);
/**
 * credit transaction
 * Stored in the services provider object in shared db as a subcollection
 * Transactions are created when:
 * 1) A credit is loaded into the account
 * 2) A credit is deducted from the account
 * 3) A credit is refunded to the account
 */
const creditTransactionMetadataSchema = z.object({
    programOwnerId: z.string(),
    placedOrderId: z.string().optional(),
    purchasedVehicleId: z.string().optional(),
    servicesProviderIds: z.array(z.string()).optional(),
    servicesProviders: z.record(z.string(), z.string()).optional(),
    ekhoCommissionAmount: z.number().optional(),
    previousBalance: z.number().optional(),
    currentBalance: z.number().optional(),
    userId: z.string().optional(),
});
const creditTransactionSchema = z.object({
    id: z.string(),
    type: creditTransactionTypeSchema,
    amount: z.number(),
    description: z.string(),
    dateCreated: z.number(),
    metadata: creditTransactionMetadataSchema,
});
/**
 * credit transaction status
 * Used to track the status of the transaction
 * NO_BALANCE: when the credits balance is 0
 * SHORTFALL: when the credits are not enough to cover the ekho commission
 * CREDITS_NOT_ENABLED: when the credits are not enabled (no credits object in SVP object)
 */
const CreditTransactionStatus = {
    NO_BALANCE: 'NO_BALANCE',
    SHORTFALL: 'SHORTFALL',
    CREDITS_NOT_ENABLED: 'CREDITS_NOT_ENABLED',
};
const creditTransactionStatusValues = [
    CreditTransactionStatus.NO_BALANCE,
    CreditTransactionStatus.SHORTFALL,
    CreditTransactionStatus.CREDITS_NOT_ENABLED,
];
const creditTransactionStatusSchema = z.enum(creditTransactionStatusValues);

export { CreditTransactionStatus, CreditTransactionType, creditTransactionSchema, creditTransactionStatusSchema, creditTransactionTypeSchema, creditsSchema };
//# sourceMappingURL=Credits.js.map
